import InfiniteScroll from "./infiniteScroll";

const InfiniteScrollWrapper = ({
  dataLength,
  next,
  scrollThreshold,
  hasMore,
  children,
  isHomePage,
}) => {
  return isHomePage ? (
    <InfiniteScroll
      dataLength={dataLength}
      next={next}
      style={{
        overflow: "hidden",
      }}
      scrollThreshold={scrollThreshold}
      hasMore={hasMore}
    >
      {children}
    </InfiniteScroll>
  ) : (
    <>{children}</>
  );
};

export default InfiniteScrollWrapper;
